<i18n>
{
	"en": {
		"title": "Copy Order",
		"numberToCopy": "Copies to Create",
		"plannedETD": "Planned Departure",
		"selectDate": "Select date",
		"copyOrder": "Copy"
	},
	"no": {
		"title": "Kopier oppdrag",
		"numberToCopy": "Antall Oppdrag",
		"plannedETD": "Planlagt Avgang",
		"selectDate": "Velg dato",
		"copyOrder": "Kopier"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:title="$t('title')"
		icon="duplicate"
		iconType="bp"
		iconColor="blue"
		width="300px"
		@close="$emit('close')"
		@shown="processShown"
	>
		<div class="dialog-mid">
			<t-form-group :title="$t('numberToCopy')">
				<t-number-input
					v-model="count"
					min="1"
				/>
			</t-form-group>
			<t-form-group :title="$t('plannedETD')">
				<div style="display:flex; margin-bottom:10px">
					<t-date-picker
						:placeholder="$t('selectDate')"
						:value="displayDateFormatter(newEtd.date)"
						:dateFormat="displayDateFormat"
						style="margin-right: 5px;"
						@input="changeEtd({dateValue: $event, hasTime: null})"
					/>
					<t-time-picker
						:value="etdTime"
						@input="changeEtd({timeValue: $event, hasTime: Boolean($event)})"
					/>
				</div>
			</t-form-group>
		</div>

		<template v-slot:footer>
			<t-button
				appearance="primary"
				class="timpex-modal-button"
				width="100%"
				@click="copyOrder"
			>
				{{$t('copyOrder')}}
			</t-button>
		</template>
	</t-dialog>
</template>
<script>
import {
	displayDateFormat, storageDateFormat, createDateObject, displayDateFormatter
} from '@/core';
import moment from 'moment';
import deepCopy from 'deepcopy';

export default {
	name: 'CopyOrderSettings',
	props: {
		isShown: Boolean,
		etd: Object,
	},
	data() {
		return {
			count: 1,
			newEtd: {
				date: '',
				hasTime: false,
				timeZone: 'Europe/Oslo',
				epoch: ''
			},
		};
	},
	computed: {
		displayDateFormat() {
			return displayDateFormat;
		},
		etdTime() {
			if (!this.newEtd.hasTime) return null;

			return this.newEtd.date ?
				moment(this.newEtd.date, storageDateFormat).format('LT') :
				undefined;
		},
	},
	methods: {
		displayDateFormatter,
		processShown() {
			this.newEtd = deepCopy(this.etd);
			this.count = 1;
		},
		copyOrder() {
			this.$emit('save',{
				count: this.count,
				newEtd: this.newEtd
			});
		},
		changeEtd({ dateValue, timeValue, hasTime }) {
			let storedDate = this.newEtd ? this.newEtd.date : undefined;
			let date = dateValue ? dateValue : storedDate;

			let time = timeValue ?
				moment(timeValue, 'LT').format('HH:mm') :
				moment(storedDate, storageDateFormat).format('HH:mm');

			hasTime = hasTime === null ?
				this.newEtd.hasTime :
				hasTime;

			this.newEtd = createDateObject({ date, hasTime, time }, Boolean(dateValue));
		}
	},
};
</script>

<style lang="scss" scoped>
.dialog-mid {
	display: grid;
	row-gap: 20px;
}
</style>

